// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The lijjjst of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // === LIVE SERVER URLs (Comment out when using local) ===
  //Latest LIVE Production URLS
  // baseUrl: "https://node.exobe.africa/api/v1/",
  // ozhoBaseUrl: "https://node.exobe.africa",

  //Latest PPD Production URLS
  baseUrl: "https://node-ernest.mobiloitte.io/api/v1/",
  ozhoBaseUrl: "https://node-ernest.mobiloitte.io",

  //Staging QA URLS
  // baseUrl: 'https://nodeexobe.mobiloitte.io/api/v1/',
  // ozhoBaseUrl: 'https://nodeexobe.mobiloitte.io',


  // === LOCAL SERVER URL (Comment out when using live) ===
  // baseUrl: 'http://localhost:3030/api/v1/',
  // ozhoBaseUrl: 'http://localhost:3030',


  // baseUrl: 'https://four-badgers-pump.loca.lt/api/v1/',
  // ozhoBaseUrl: 'https://four-badgers-pump.loca.lt',
  

  //   baseUrl: 'https://shaky-birds-play.loca.lt/api/v1/',
  // ozhoBaseUrl: 'https://shaky-birds-play.loca.lt',

  // === LOCAL SERVER URL (Comment out when using live) ===
  // baseUrl: 'https://5e0c24e47687.ngrok-free.app/api/v1/',
  // ozhoBaseUrl: 'https://5e0c24e47687.ngrok-free.app',

  // Other developer URLs
  // baseUrl: 'http://172.16.6.83:3030/api/v1/', //Izhar
  // ozhoBaseUrl: 'http://172.16.6.83:3030',

  webUrl: window.location.protocol + '//' + window.location.host + '/',
  // chatbotApiUrl: 'https://pymobiloitte3rd-chatbot.mobiloitte.io/temp-chat'

  // chatbotApiUrl: 'https://py-exobechatbot.mobiloitte.io/temp-chat',

  //Latest LIVE Production URL for Python Chatbot
  chatbotApiUrl: 'https://py.exobe.africa/temp-chat',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
